<template>
  <div>
    <div class="lab-search bg-primary-light p-3 mt-3" :class="{'d-flex align-items-center justify-content-center':'!initialloading'}">
      <div class="spinner-wrapper mx-auto" v-if="initialloading">
        <div class="spinner-border d-block" role="status">
          <span class="visually-hidden">Loading...</span>
        </div>
      </div>
      <form v-show="!initialloading" @submit.prevent>
        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend class="fw-bold fs-6 mb-0 mt-n1">Group by</legend>
              <ul class="list-unstyled d-flex align-items-center gap-3">
                <li>
                  <input type="radio" id="intervention" value="intervention" v-model="filters.groupedBy">
                  <label for="intervention" class="fs-8 text-dark">Intervention</label>
                </li>
                <li>
                  <input type="radio" id="local_example" value="local_example" v-model="filters.groupedBy">
                  <label for="local_example" class="fs-8 text-dark">Local Example</label>
                </li>
                <li>
                  <input type="radio" id="innovator_counties" value="innovator_counties" v-model="filters.groupedBy">
                  <label for="innovator_counties" class="fs-8 text-dark">Innovator Counties</label>
                </li>  
              </ul>
            </fieldset>
          </div>
          <div class="col-lg-6">
            <fieldset>
              <legend class="fw-bold fs-6 mb-0 mt-lg-n1">Type</legend>
              <ul class="list-unstyled col2">
                <li v-for="t in types" class="fs-8 text-dark">
                  <input type="checkbox" :id="t.id" :value="t.id" v-model="filters.types">
                  <label :for="t.id" class="d-block" v-html="t.name"></label>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>  
        <div class="row">
          <div class="col-lg-6">
            <fieldset>
              <legend class="fw-bold fs-6 mb-0">Measure</legend>
              <ul class="list-unstyled col2">
                <li v-for="measure in measures" class="fs-8 text-dark">
                  <input type="checkbox" :id="measure.id" :value="measure.id" v-model="filters.measures">
                  <label :for="measure.id" class="d-block">{{ measure.name }}</label>
                </li>
              </ul>
            </fieldset>
          </div>
          <div class="col-lg-6">
            <fieldset>
              <legend class="fw-bold fs-6 mb-0">Category</legend>
              <ul class="list-unstyled col2">
                <li v-for="category in categories" class="fs-8 text-dark">
                  <input type="checkbox" :id="category.id" :value="category.id" v-model="filters.categories">
                  <label :for="category.id" class="d-block">{{ category.name }}</label>
                </li>
              </ul>
            </fieldset>
          </div>
        </div>  
        <div class="row">
          <div class="col-lg-6">
            <label class="fw-bold fs-6">Local examples</label>
            <multiselect v-model="filters.local_examples" :options="local_examples.map(local_example => local_example.id)" :multiple="true" :disabled="initialloading" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick one or more" :custom-label="opt => local_examples.find(x => x.id == opt).name" id="local-examples" :preselect-first="false">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
            </multiselect>
          </div>
          <div class="col-lg-6">
            <label class="fw-bold fs-6">Intervention</label>
            <multiselect v-model="filters.interventions" :options="entries.map(entry => entry.id)" :multiple="true" :disabled="initialloading" :close-on-select="false" :clear-on-select="false" :preserve-search="true" placeholder="Pick one or more" :custom-label="opt => entries.find(x => x.id == opt).title" id="interventions" :preselect-first="false">
              <template slot="selection" slot-scope="{ values, search, isOpen }"><span class="multiselect__single" v-if="values.length &amp;&amp; !isOpen">{{ values.length }} options selected</span></template>
            </multiselect>
          </div>
        </div>
        <div class="row align-items-center mt-4"> 
          <div class="col-lg-6">
            <p class="fw-bold fs-6 mb-lg-0">Results: {{ resultsLength }}</p>
          </div>  
          <div class="col-lg-6 d-lg-flex align-items-center justify-content-end">
            <button class="btn btn-red btn-sm mb-3 mb-lg-0 me-2" @click="apply">Apply</button>
            <button class="btn btn-light btn-sm mb-lg-0 mb-3" @click="reset">Reset</button>
          </div>
        </div>
      </form>
    </div>
    <div class="row mt-4">
      <div class="col-lg-6">
        <form method="post" :action="adminPost">
          <input type="hidden" name="action" value="export">
          <input type="hidden" name="frontend_nonce" :value="nonce" />
          <input type="hidden" name="data" :value="JSON.stringify(displayedEntries)" />
          <input type="hidden" name="exporttype" :value="groupedBy" />
          <button type="submit" class="btn btn-sm rounded-0 px-4 btn-secondary text-dark" :disabled="initialloading">Export Results</button>
        </form>
      </div>
      <div class="col-lg-6 d-flex align-items-center justify-content-end" v-if="groupedBy === 'intervention'">
        <p class="fw-bold fs-6 me-3">Show:</p>
        <ul class="list-unstyled d-flex align-items-center gap-3">
          <li>
            <input type="radio" id="show_intervention" value="intervention" v-model="filters.show" :disabled="initialloading">
            <label for="show_intervention" class="fs-8 text-dark">Intervention</label>
          </li> 
          <li>
            <input type="radio" id="show_local_example" value="local_example" v-model="filters.show" :disabled="initialloading">
            <label for="show_local_example" class="fs-8 text-dark">Local Example</label>
          </li>
        </ul>
      </div>
    </div>
    <section>
      <div class="bg-light mt-4 p-4 mb-4" v-for="i in 10" v-if="initialloading">
        <h5 class="d-block skeleton-loader skeleton-h5 bg-gray-400 w-50"></h5>
        <div class="d-block skeleton-loader skelton-description mb-3 bg-gray-400 w-100"></div>
        <div class="d-block skeleton-loader skelton-terms bg-gray-400 w-50"></div>
      </div>

      <div v-if="groupedBy === 'intervention' && loading == false">
        <div v-for="(intervention, key) in displayedEntries.slice((currentPage * 10) - 10, currentPage * 10)" :key="key" class="bg-light mt-4 p-4 mb-4">
          <h5><a :href="siteURL+'/resource_lab/'+intervention.slug" class="text-primary-medium border-0">{{ intervention.title }}</a></h5>
          <div class="fs-6 entry-excerpt mb-n2" v-html="intervention.post_excerpt"></div>

          <div v-if="filters.show == 'intervention'">
            <div class="d-flex gap-2 fs-8">
              <p class="mb-0"><strong class="fw-bold text-dark">Type</strong></p>
              <ul class="mb-0 list-unstyled d-flex gap-4">
                <li v-for="(type, index) in intervention.typestax" :key="index" v-html="type.name"></li>
              </ul>
            </div>

            <div class="d-flex gap-2 fs-8">
              <p class="mb-0"><strong class="fw-bold text-dark">Measures</strong></p>
              <ul class="mb-0 list-unstyled d-flex gap-4">
                <li v-for="(measure, index) in intervention.measures" :key="index" v-html="measure.name"></li>
              </ul>
            </div>

            <div class="d-flex gap-2 fs-8">
              <p class="mb-0"><strong class="fw-bold text-dark">Categories</strong></p>
              <ul class="mb-0 list-unstyled d-flex gap-4">
                <li v-for="(c, index) in intervention.categories" :key="index" v-html="c.name"></li>
              </ul>
            </div>
          </div> 
          <div v-if="filters.show == 'local_example'" class="d-flex gap-2 fs-8">
              <ul class="mt-2 mb-0 list-unstyled">
                <li class="mb-2" v-for="(example, index) in intervention.local_example" :key="index" v-html="example.name"></li>
              </ul>
          </div> 
        </div>
      </div>

      <div v-if="(groupedBy === 'local_example' || groupedBy === 'innovator_counties') && loading == false">
        <div v-for="(local_example, key) in displayedEntries.slice((currentPage * 10) - 10, currentPage * 10)" :key="key" class="bg-light mt-4 p-4 mb-4">
          <h5 class="mb-2">{{ local_example.name }}</h5>
          <ul class="list-unstyled fs-8">
            <li v-for="example in local_example.entries" :key="example.id" class="mb-2"><a :href="siteURL+'/resource_lab/'+example.slug" class="text-primary-medium border-0">{{ example.title }}</a></li>
          </ul>
        </div>
      </div>

      <nav aria-label="Page navigation" v-if="!loading && totalPages > 1">
        <ul class="pagination">
          <li class="page-item" :class="{ 'disabled' : !hasPreviousPage }"><span class="page-link" tabindex="-1" :aria-disabled=" !hasPreviousPage " @click="changePage('prev')">Previous</span></li>
          <li class="page-item" :class="{ 'active': index + 1 == currentPage }" v-for="(t, index) in totalPages" :key="index + 1" @click="changePage(index + 1)"><span class="page-link">{{ index + 1 }}</span></li>
          <li class="page-item" :class="{ 'disabled' : !hasNextPage }"><span class="page-link" :aria-disabled=" !hasNextPage " @click="changePage('next')">Next</span></li>
        </ul>
      </nav>
    </section>  
  </div>
</template>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
@media(min-width: 1000px) {
  .col2 {
    column-count: 2;
  }
  .lab-search {
    height: 444px;
  }
}

.multiselect__option--highlight,
.multiselect__option--highlight::after,
.multiselect__tag {
  background-color: #457776;
}

.multiselect__tag-icon:after {
  color: #fff;
}
.multiselect__tag-icon:focus,
.multiselect__tag-icon:hover {
  background: #457776;
}

.multiselect__option--group-selected.multiselect__option--highlight:after {
  background: #d53b34;
}

.multiselect__option--selected.multiselect__option--highlight {
    background: #d53b34;
}
.multiselect__option--selected.multiselect__option--highlight:after {
    background: #d53b34;
}
.multiselect__option--group-selected.multiselect__option--highlight {
    background: #d53b34;
}
.multiselect__option--group-selected.multiselect__option--highlight:after {
    background: #d53b34;
}

.multiselect  {
  height: 40px;
}
.multiselect__tags {
  padding: 6px 40px 0 40px;
}
.multiselect__single {
    padding-left: 0;
}

.multiselect__placeholder {
  margin-left: 0.5rem;
}

.skeleton-h5 {
    height: 30px;
  }
  .skelton-description {
    height: 170px;
  }
  .skelton-terms {
    height: 80px;
  }
  .skelton-nav {
    height: 40px;
    width: 430px;
  }
  .meta-total {
    font-family: "GT-America Light", sans-serif;
    font-weight: 100;
    line-height: 1;
  }
  .spinner-wrapper {
    align-items: center;
    display: flex;
    height: 92px;
  }
  .page-link {
    cursor: pointer;
  }
  .page-item.active .page-link {
    color: black;
  }
  .search-input {
    height: 35px;
  }
  .multiselect  {
    height: 40px;
  }
  .multiselect__tags {
    padding: 8px 40px 0 0.5rem;
  }
  .multiselect__single {
      padding-left: 0;
  }

</style>

<script>
import { nullLiteral } from '@babel/types';
import Multiselect from 'vue-multiselect';

export default {
  components: { Multiselect },
  data() {
    return {
      adminPost: null,
      categories: [],
      currentPage: 1,
      displayedEntries: [],
      entries: [],
      filters: {
        categories: [],
        interventions: [],
        groupedBy: 'intervention',
        local_examples: [],
        measures: [],
        show: 'intervention',
        types: [],
      },
      groupedBy: 'intervention',
      hasNextPage: false,
      hasPreviousPage: false,
      initialloading: true,
      loading: true,
      local_examples: [],
      measures: [],
      nonce: null,
      perPage: 10,
      resultsLength: 0,
      siteURL: null,
      totalPages: 1,
      types: [],
    }
  },
  mounted() {
    this.siteURL = document.querySelector("[data-site-url]").dataset.siteUrl;
    this.nonce = document.querySelector("[data-fronteend-nonce]").dataset.fronteendNonce;
    this.adminPost = document.querySelector("[data-admin-url]").dataset.adminUrl + "?action=export";
    
    this.loadEntries();
  },
  methods: {
    apply() {
        this.filterEntries();
    },
    changePage(type) {
      if(type == 'next') {
        this.currentPage = this.currentPage + 1

      } else if(type == 'prev') {
        this.currentPage = this.currentPage - 1

      } else {
        this.currentPage = type
      }

      if(this.currentPage > 1 && this.currentPage < this.totalPages) {
        this.hasNextPage = true
      } else {
        this.hasNextPage = false
      }

      if(this.currentPage <= 1) {
        this.hasPreviousPage = false
      } else {
        this.hasPreviousPage = true
      }
    },
    filterEntries() {
      const vm = this

      vm.groupedBy = vm.filters.groupedBy

      const filteredEntries = vm.entries.filter(entry => {
          if(vm.filters.categories.length > 0 && !entry.categories.filter(function(e) { return vm.filters.categories.includes(e.id); }).length > 0) { 
              return false;
          }

          if(vm.filters.interventions.length > 0 && !vm.filters.interventions.includes(entry.id)) { 
              return false;
          }

          if(vm.filters.local_examples.length > 0 && !entry.local_example.filter(function(e) { return vm.filters.local_examples.includes(e.id); }).length > 0) { 
              return false;
          }

          if(vm.filters.measures.length > 0 && !entry.measures.filter(function(e) { return vm.filters.measures.includes(e.id); }).length > 0) { 
              return false;
          }

          if(vm.filters.types.length > 0 && !entry.typestax.filter(function(e) { return vm.filters.types.includes(e.id); }).length > 0) { 
              return false;
          } 

          return true;
      });

      vm.displayedEntries = vm.groupBy(filteredEntries);

    },
    groupBy(entries) {
      const vm = this
      let cleanedGroups = [];
      let innovatorCounties = [];
      let newGroups = [];
      let counter = 0;
      if(vm.groupedBy == "local_example" || vm.groupedBy == "innovator_counties") {

        Object.keys(entries).forEach(key => {
          entries[key].local_example.forEach(function(location) {
            if (cleanedGroups.indexOf(location.name) == -1) cleanedGroups.push(location.name)
            if (location.acf.innovator_county[0]) innovatorCounties.push(location.name)
          });
        });
          cleanedGroups.forEach(function(location) {
          let newGroup = {
            name: location,
            innovator_county: false, 
            entries: []
          }

          if(innovatorCounties.includes(location)) {
            newGroup.innovator_county = true;
          }

          Object.keys(entries).forEach(key => {
            entries[key].local_example.forEach(function(entryLocation) {
              if(entryLocation.name == location) {
                newGroup.entries.push(entries[key])
                counter++;
              }
            });
          });

          newGroups.push(newGroup)
        });

        if(vm.groupedBy == "innovator_counties") {
          counter = 0;
          newGroups = newGroups.filter(function(group) {
            if( group.innovator_county == true) {
              counter++;
              return true
            }
          });
        }

        // alphabetize newGroups by name
        newGroups.sort(function(a, b) {
          var nameA = a.name.toUpperCase(); // ignore upper and lowercase
          var nameB = b.name.toUpperCase(); // ignore upper and lowercase
          if (nameA < nameB) {
            return -1;
          }
          if (nameA > nameB) {
            return 1;
          }

          // names must be equal
          return 0;
        });
        
        vm.resultsLength = counter;
        return newGroups;
      } else if(vm.groupedBy == "intervention") {
        vm.resultsLength = entries.length;
        return entries;
      }    
    },
    async loadEntries() {
      this.entries = await this.loadJSON('resource_lab?_fields=id,title,slug,content,categories,typestax,measures,local_example,acf&orderby=title&order=asc');
      this.displayedEntries = this.entries;
      this.local_examples = await this.loadJSON('local_example?_fields=id,name,slug,acf&orderby=name&order=asc');
      this.measures = await this.loadJSON('measures?_fields=id,name,slug&orderby=name&order=asc');
      this.types = await this.loadJSON('typestax?_fields=id,name,slug&orderby=name&order=asc');
      this.categories = await this.loadJSON('categories?_fields=id,name,slug&orderby=name&order=asc&exclude=1,3,4,5,95');

      this.translateLocalExampleIDs(this.entries);
      this.translateMeasureIDs(this.entries);
      this.translateTypeIDs(this.entries);
      this.translateCategoryIDs(this.entries);

      this.resultsLength = this.entries.length;

      this.moveTitle(this.entries);
      this.initialloading = false;
      this.loading = false;
    },
    async loadJSON(url) {
      const vm = this
      let jsoncurrentPage = 1;
      let totalPages = 0;
      let entries = [];
      let morePages = true;

      while(morePages) {
        let response = await fetch(`/wp-json/wp/v2/${url}&per_page=25&page=${jsoncurrentPage}`);
        totalPages = response.headers.get('x-wp-totalpages');

        const data = await response.json();
        entries = entries.concat(data);

        if(!totalPages || totalPages == jsoncurrentPage) {
          morePages = false;
        } else {
          jsoncurrentPage = jsoncurrentPage + 1;
        }
      }

      return entries;
    },
    moveTitle(entries) {
      const vm = this;
      entries.forEach(function(entry, i) {
        entries[i]['title'] = entry['title'].rendered;
      });

      vm.entries = entries;
      vm.displayedEntries = entries;
    },
    reset() {
      const vm = this
      vm.currentPage = 1,
      vm.displayedEntries = vm.entries
      vm.filters.categories = [] 
      vm.filters.interventions = [] 
      vm.filters.groupBy = 'intevention'
      vm.filters.local_examples = [] 
      vm.filters.measures = [] 
      vm.filters.types = [] 
      vm.show = 'intevention'
      vm.groupedBy = 'intervention'
      vm.hasNextPage = false
      vm.hasPreviousPage = false
      vm.resultsLength = vm.entries.length
      vm.totalPages = Math.floor(vm.entries.length/10)
    },
    translateCategoryIDs(entries) {
      const vm = this;
      entries.forEach(function(entry, i) {
        let updates = [];

        entry['categories'].forEach(function(c) {
          updates.push(vm.categories.find(category => category.id == c));
        });
        entries[i]['categories'] = updates;
      });

      vm.entries = entries;
      vm.displayedEntries = entries;
    },
    translateLocalExampleIDs(entries) {
      const vm = this;
      entries.forEach(function(entry, i) {
        let updates = [];

        entry['local_example'].forEach(function(local_example) {
          updates.push(vm.local_examples.find(example => example.id == local_example));
        });
        entries[i]['local_example'] = updates;
      });
      vm.entries = entries;
      vm.displayedEntries = entries;
    },
    translateMeasureIDs(entries) {
      const vm = this;
      entries.forEach(function(entry, i) {
        let updates = [];

        entry['measures'].forEach(function(m) {
          updates.push(vm.measures.find(measure => measure.id == m));
        });
        entries[i]['measures'] = updates;
      });
      vm.entries = entries;
      vm.displayedEntries = entries;
    },
    translateTypeIDs(entries) {
      const vm = this;
      entries.forEach(function(entry, i) {
        let updates = [];

        entry['typestax'].forEach(function(t) {
          updates.push(vm.types.find(type => type.id == t));
        });
        entries[i]['typestax'] = updates;
      });
      vm.entries = entries;
      vm.displayedEntries = entries;
    }

  },
  watch: {
    displayedEntries: function() {
      this.totalPages = Math.ceil(this.displayedEntries.length / this.perPage);
      if(this.totalPages > 1) {
        this.hasNextPage = true;
      } else {
        this.hasNextPage = false;
      }
    },
  },
}
</script>
